// Querys and Mutations
import {
  ALL_ACTIVE,
  GET_WITH_PAGINATION,
  CHANGE_STATUS,
  CREATE,
  UPDATE,
  DELETE,
  VALIDATE_NAME,
  ALL_ACTIVE_AND_ONLY_PIECEWORK
} from '@/graphql/config/WorkDescriptionGraphql'

// models
import { Paginator, ResponseDefault, ResponseCustom } from '@/models'
import { WorkDescriptionModel, WorkDescriptionForm, WorkDescriptionsWithPagination } from '@/models/config'

// apollo
import { apolloClient } from '@/apollo'

class WorkDescriptionService {
  async getActivated (): Promise<WorkDescriptionModel[]> {
    const result = await apolloClient.query({
      query: ALL_ACTIVE
    })
    return result.data.workDescriptionsActive
  }

  async getActivatedAndOnlyPiecework (): Promise<WorkDescriptionModel[]> {
    const result = await apolloClient.query({
      query: ALL_ACTIVE_AND_ONLY_PIECEWORK
    })
    return result.data.workDescriptionsActiveAndOnlyPiecework
  }

  async getWithPagination (perPage = 10, page = 1): Promise<WorkDescriptionsWithPagination> {
    const result = await apolloClient.query({
      query: GET_WITH_PAGINATION,
      variables: {
        page: page,
        perPage: perPage
      }
    })
    const pagination: Paginator = result.data.workDescriptionsWithPagination.paginatorInfo
    const data: WorkDescriptionModel[] = result.data.workDescriptionsWithPagination.data
    const response: WorkDescriptionsWithPagination = {
      objects: data,
      pagination: pagination
    }
    return response
  }

  /**
   * Mutations
   */
  async validateName (name: string): Promise<ResponseCustom> {
    const result = await apolloClient.mutate({
      mutation: VALIDATE_NAME,
      variables: {
        name: name
      }
    })
    const response = result.data.validateNameWorkDescription
    return {
      success: response.success,
      msg: response.msgError
    }
  }

  async create (form: WorkDescriptionForm): Promise<WorkDescriptionModel> {
    const result = await apolloClient.mutate({
      mutation: CREATE,
      variables: {
        input: form
      }
    })
    return result.data.createWorkDescription
  }

  async update (id: number, form: WorkDescriptionForm): Promise<WorkDescriptionModel> {
    const result = await apolloClient.mutate({
      mutation: UPDATE,
      variables: {
        id: id,
        input: form
      }
    })
    return result.data.updateWorkDescription
  }

  async changeStatus (id: number, status: boolean): Promise<ResponseDefault> {
    await apolloClient.mutate({
      mutation: CHANGE_STATUS,
      variables: {
        id: id,
        input: {
          is_active: status
        }
      }
    })
    return {
      success: true,
      errors: []
    }
  }

  async delete (id: number): Promise<ResponseDefault> {
    await apolloClient.mutate({
      mutation: DELETE,
      variables: {
        id: id
      }
    })
    return {
      success: true,
      errors: []
    }
  }
}

export default new WorkDescriptionService()
